import { AxiosResponse } from 'axios'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { FileError } from 'react-dropzone'
import { Meta } from 'util/metaPath'

import { FileUploaderComponent, FileUploaderProps } from './FileUploaderComponent'

interface FileUploaderFieldProps<T> extends FileUploaderProps {
  name: string | (T extends any[] ? never : Meta<T>)
}

export function FileUploaderField<T>(props: FileUploaderFieldProps<T>) {
  const { name, onRejection, ...rest } = props

  const {
    input: { onChange: updateField },
  } = usePecField<T>({ name })

  const handleOnUploadSuccessful = (response: AxiosResponse<T>) => {
    updateField(response.data)
  }

  const handleOnRejection = (errors: FileError[]) => {
    updateField(null)
    onRejection?.(errors)
  }

  return (
    <FileUploaderComponent onUploadSuccessful={handleOnUploadSuccessful} onRejection={handleOnRejection} {...rest} />
  )
}
